import { create } from "zustand"

interface AllQuestsMultiSelectStore {
  selectedQuestSeriesIds: number[]
  setSelectedQuestSeriesIds: (selectedQuestSeriesIds: number[]) => void
  toggleQuestSeriesId: (questSeriesId: number) => void
}

const useAllQuestsMultiSelectStore = create<AllQuestsMultiSelectStore>(
  (set) => ({
    selectedQuestSeriesIds: [],
    setSelectedQuestSeriesIds: (selectedQuestSeriesIds) =>
      set({ selectedQuestSeriesIds }),
    toggleQuestSeriesId: (questSeriesId) =>
      set((state) => ({
        selectedQuestSeriesIds: state.selectedQuestSeriesIds.includes(
          questSeriesId
        )
          ? state.selectedQuestSeriesIds.filter((id) => id !== questSeriesId)
          : [...state.selectedQuestSeriesIds, questSeriesId],
      })),
  })
)

export default useAllQuestsMultiSelectStore
